import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { ISelectItem } from '@cakeiteasy/web-ui';
import { Subject } from 'rxjs';
import { CustomComponent, ngHelper, IReminderGroupReminder } from '@cakeiteasy/web-utils';
import { filter, debounceTime } from 'rxjs/operators';

@Component({
  standalone: false,
  selector: 'cake-reminder',
  templateUrl: './cake-reminder.component.html',
  styleUrls: ['./cake-reminder.component.scss']
})
export class CakeReminderComponent extends CustomComponent implements OnInit, OnChanges {
  @Input() reminder: IReminderGroupReminder;
  @Input() reminderReasons: ISelectItem[];

  @Output() onSaving = new EventEmitter<IReminderGroupReminder>();
  @Output() onRemoving = new EventEmitter<number>();

  public reason: ISelectItem;
  public onFieldUpdate = new Subject<{ isValid: boolean }>();

  constructor() {
    super();
  }

  ngOnInit() {
    const reminderUpdatedSub = this.onFieldUpdate
      .pipe(filter((data) => data.isValid && Boolean(this.reminder.id)))
      .pipe(debounceTime(300))
      .subscribe((reminder) => {
        this.onSaving.emit(this.reminder);
      });

    this.addSubscriber(reminderUpdatedSub);
  }

  public ngOnChanges(changes: SimpleChanges) {
    return ngHelper.ifChanged(changes, 'reminder', (reminder) => {
        this.reason = this.reminderReasons.find((reason) => {
          return reason.value === reminder.reason;
        });

        if (!this.reason) {
          this.reason = this.reminderReasons[0];
        }

        if (!this.reminder.targetDate) {
          this.reminder.targetDate = null;
        }
      }
    );
  }
}

